import { Config, isLoopbackUrl } from "@amtana/module";
import { z } from "zod";

// Where the scan reads Instagram from. HikerAPI in production; in development
// and tests the hikersim simulator (sims/hikersim), which answers the same wire.
export const analysisConfig = Config.define((c) => ({
  hikerApiBase: c.env("HIKER_API_BASE", z.url().default("http://127.0.0.1:4320"), {
    // sims/hikersim/adrs/001 point 5: the api refuses a loopback HIKER_API_BASE in production.
    refuseInProduction: (value) => (isLoopbackUrl(value) ? "points at a loopback host, hikersim" : undefined),
  }),
  hikerApiKey: c.env("HIKER_API_KEY", z.string().min(1).default("hikersim")),
  /** HikerAPI's paid plans allow 15 requests per second. */
  hikerRatePerSecond: c.env("HIKER_RATE_PER_SECOND", z.coerce.number().positive().default(15)),
  /** The breaker's first cooldown after HikerAPI stops answering; it doubles to ten times this (ADR-002). */
  hikerBreakerCooldownMs: c.env(
    "HIKER_BREAKER_COOLDOWN_MS",
    z.coerce.number().int().positive().default(30_000),
  ),
  /**
   * Lets a test or a local run use the modes no provider reads: they advance when read, write
   * generated people into prospects and spend credits on them (D1155). Off unless asked for.
   */
  simulatedSources: c.env(
    "ANALYSIS_SIMULATED_SOURCES",
    z
      .enum(["true", "false"])
      .default("false")
      .transform((value) => value === "true"),
    {
      refuseInProduction: (value) =>
        value ? "charges real credits for generated people in the customer's prospects" : undefined,
    },
  ),
}));
